/**
 * Configurações da Agenda.
 *
 * O módulo já teve um store Vuex (`clinicDays` + `clinicExceptions`) que
 * existia para alimentar um único getter, `hasClinicConflict`, consumido só
 * pelo formulário de exceção em Vue. Esse getter virou função pura em
 * `react-apps/schedule-config/operation/lib/exceptions.ts`, sobre os dias que
 * a tela já carrega — e o store ficou sem leitor. Sobrou o router.
 */

import router from './router'

export default {
  router
}
